import { createComponentExtension, createPlugin } from '@backstage/core-plugin-api'

import { rootRouteRef } from './routes'

export const cloudCostPlugin = createPlugin({
  id: 'cloud-cost',
  routes: {
    root: rootRouteRef
  }
})

export const EntityCloudCostCard = cloudCostPlugin.provide(
  createComponentExtension({
    name: 'EntityCloudCostCard',
    component: {
      lazy: () =>
        import('./components/EntityCloudCostCard').then(m => m.EntityCloudCostCard)
    }
  })
)
